import { Modal, TableCustom } from "../../common"
import { getDateToString, getFormatNumber, getNumeroRecibo_ObjectToIdentificador } from "../../../utils/convert"
import { ServerRequest } from "../../../utils/apiweb"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../../config/apis"
import { onRequestError, onRequestNoSuccess } from "../../../utils/requests"
import { useEffect, useState } from "react"
import { useManagedContext } from "../../hooks"
const RecaudacionesNoConciliadasGridModal = ({ idRecaudacionLote, onVolver }) => {

    const {setIsLoading, showMessageModal} = useManagedContext()

    const [recaudaciones, setRecaudaciones] = useState([])
    const [hasChanges, setChanges] = useState(false)

    useEffect(() => {
        if (idRecaudacionLote > 0) {
            SearchRecuadaciones(idRecaudacionLote)
        }
    }, [])

    const filterData = data => {
        let filtered = [...data]

        filtered = filtered.filter(item => !item.fechaConciliacion)

        filtered.forEach(item => {
            item.selected = false
        })

        return filtered
    }

    const SearchRecuadaciones = (idRecaudacionLote) => {
        setIsLoading(true)

        const paramsUrl = `/detalle/${idRecaudacionLote}`

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.RECAUDACION_LOTE,
            paramsUrl,
            null,
            res => res.json().then(data => {
                data.forEach(x => {
                    if (x.fechaConciliacion) x.fechaConciliacion = new Date(x.fechaConciliacion)
                })
                setRecaudaciones(filterData(data))
                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const confirmConciliacionesManuales = () => {
        setIsLoading(true)

        const idsRecaudacion = recaudaciones.filter(f => f.selected).map(x => x.id)

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.RECAUDACION_LOTE,
            '/conciliacion/manual',
            { idsRecaudacion },
            res => res.json().then(({ idsReconciliadas, idsReconciliacionesFalladas }) => {
                if (idsReconciliadas.length > 0) setChanges(true)
                setRecaudaciones(prev => {
                    const updated = prev.filter(x => !idsReconciliadas.includes(x.id))
                    updated.forEach(item => {
                        item.selected = false
                    })
                    return updated
                })

                if (idsReconciliacionesFalladas.length > 0) {
                    ShowToastMessage(ALERT_TYPE.ALERT_WARNING, `${idsReconciliadas.length} conciliadas. ${idsReconciliacionesFalladas.length} no se pudieron conciliar.`)
                } else {
                    ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, 'Conciliación aplicada correctamente')
                }

                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const onSelected = (selected) => {
        const newRecaudaciones = [...recaudaciones]
        for (let i = 0; i < selected.length; i++) {
            for (let j = 0; j < newRecaudaciones.length; j++) {
                if (newRecaudaciones[j].id === selected[i].id) {
                    newRecaudaciones[j].selected = selected[i].selected
                    break
                }
            }
        }
        setRecaudaciones(newRecaudaciones)
    }

    const handleConfirmar = () => {
        const seleccionadas = recaudaciones.filter(f => f.selected)
        if (seleccionadas.length === 0) return ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe seleccionar al menos una recaudación')

        showMessageModal({
            title: "Confirmación",
            message: `¿Está seguro/a de aplicar la conciliación a ${seleccionadas.length} recaudación/es?`,
            onConfirm: () => confirmConciliacionesManuales(),
        })
    }

    return (
        <>

        <Modal
            onEscape={() => onVolver(hasChanges)}
            allowFullscreen={true}
            size="xl"
            title="Recaudaciones no conciliadas"
            body={(
                <TableCustom
                    className={'TableCustomBase m-top-10'}
                    data={recaudaciones}
                    useSelectedField
                    selectionAllowed={(row) => !!row.idReciboPublicacion}
                    onItemsSelected={onSelected}
                    selectionLabelAccessor={(item) => `${getNumeroRecibo_ObjectToIdentificador(item) || `#${item.numeroControl}`} - $${getFormatNumber(item.importeCobro, 2)}`}
                    columns={[
                        { Header: 'N° control', accessor: 'numeroControl', width: '10%' },
                        { Header: 'N° cuenta', accessor: 'numeroCuenta', width: '10%' },
                        { Header: 'N° VEP', accessor: 'numeroRecibo', width: '15%', Cell: ({ row }) =>  getNumeroRecibo_ObjectToIdentificador(row.original) },
                        { Header: 'Fecha de cobro', accessor: 'fechaCobro', Cell: (data) => getDateToString(data.value), width: '10%' },
                        { Header: 'Importe', accessor: 'importeCobro', Cell: (data) => getFormatNumber(data.value, 2), width: '12%', alignCell: 'right' },
                        { Header: 'Observación', accessor: 'observacion', width: '38%' },
                    ]}
                    showDownloadCSV={false}
                />
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={() => onVolver(hasChanges)}>Volver</button>
                    <button className="btn action-button float-end" onClick={handleConfirmar}>Confirmar</button>
                </div>
            )}
        />

        </>
    )
}

export default RecaudacionesNoConciliadasGridModal
